import * as actions from '../actions/submittedPolicy';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestPostedApplicationMessage(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_POSTED_APPLICATION_MESSAGE)
        .map(action => ({
            url: BASE_URL + 'api/applications/'+action.payload.applicationId+'/submittedMessage',
            category: 'requestPostedApplicationMessage',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestPostedApplicationMessage')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getPostedApplicationMessageSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestPostedApplicationMessageFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestPostedApplicationMessage')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getPostedApplicationMessageFail(response));

    return {
        ACTION: httpResponse$
    };
}